<template>
  <div id="pageTable">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field

                flat
                hide-details
                :placeholder="$t('search')"
                prepend-icon="search"
                solo
                v-model="search"
              ></v-text-field>
              <v-btn
                v-if="edit && can('create', 'team')"
                @click="sendEmit('create')"
                color="primary"
                small
              >{{$t('new')}}</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="text-xs-center pa-0">
              <v-data-table
                :headers="headers"
                :items="formatList"
                :loading="loading"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                :search="search"
                class="elevation-1"
                item-key="name"
              >
                <template slot="items" slot-scope="props">
                    <td class="justify-center px-0">
                      <v-btn color="primary" class="mx-0" flat icon small>
                        <v-icon
                          @click="sendEmit('view', props.item)"
                          class="icon material-icons"
                        >visibility</v-icon>
                      </v-btn>
                      <template v-if="edit">
                      <v-btn
                        v-if="can('edit', 'team', props.item)"
                        color="success"
                        class="mx-0"
                        flat
                        icon
                        small
                      >
                        <v-icon
                          @click="sendEmit('update', props.item)"
                          class="icon material-icons"
                        >create</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="can('delete', 'team', props.item)"
                        color="error"
                        class="mx-0"
                        flat
                        icon
                        small
                      >
                        <v-icon
                          @click="sendEmit('delete', props.item)"
                          class="icon material-icons"
                        >delete</v-icon>
                      </v-btn>
                      </template>
                    </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{props.item.entity}}</td>
                  <td>{{props.item.category}}</td>
                  <td>{{props.item.createdAt}}</td>
                  <td>{{props.item.createdBy }}</td>
                  <td>{{props.item.updatedAt}}</td>
                  <td>{{ props.item.updatedBy }}</td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { dateFormat } from '../../../helpers/dateHelper'

export default {
  name: 'list',
  props: {
    filterEntity: {
      type: Object,
      default: () => {
        return {}
      },
      required: false
    },
    edit: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      status: false,
      search: ''
    }
  },
  computed: {
    ...mapState({
      entity: state => state.entities.entitySelected,
      listTeams: state => state.teams.listTeams,
      listCountries: state => state.countries.list,
      listProvinces: state => state.provinces.list,
      listTowns: state => state.cities.list,
      listUser: state => state.users.listaUsers,
      listLanguages: state => state.languages.listLanguages,
      loading: state => state.teams.loading,
      listCategories: state => state.categories.list
    }),
    headers () {
      let result = []

      // if (this.edit) {
      result.push({
        text: this.$t('actions'),
        align: 'center',
        value: ''
      })
      // }
      result = result.concat([
        {
          text: this.$t('name'),
          align: 'center',
          value: 'name'
        },
        {
          text: this.$tc('entity'),
          align: 'center',
          value: 'entity'
        },
        {
          text: this.$tc('category'),
          align: 'center',
          value: 'category'
        },
        {
          text: this.$t('createdAt'),
          align: 'center',
          value: 'createdAt'
        },
        {
          text: this.$t('createdBy'),
          align: 'center',
          value: 'createdBy'
        },
        {
          text: this.$t('updatedAt'),
          align: 'center',
          value: 'updatedAt'
        },
        {
          text: this.$t('updatedBy'),
          align: 'center',
          value: 'updatedBy'
        }
      ])

      return result
    },
    formatList () {
      let formatedList = this.listTeams
      if (this.filterEntity && this.filterEntity._id) { formatedList = formatedList.filter(team => team.entityId == this.filterEntity._id) }

      formatedList = formatedList.map(team => {
        return {
          ...team,
          entity: team.entityName,
          category: this.formatCategory(team.categoryId),
          createdAt: dateFormat(team.createdAt),
          updatedAt: dateFormat(team.updatedAt)
        }
      })
      return formatedList
    }
  },
  methods: {
    ...mapActions({
      setEntity: 'teams/setEntity'
    }),
    dateFormat (value) {
      return dateFormat(value, false)
    },
    sendEmit (evento, id = null) {
      if (evento !== 'delete' && evento !== 'create' && evento !== 'update' && evento !== 'view') {
        return
      }
      let element = null
      if (id) {
        element = {
          idEntity: id.entityId,
          idTeam: id._id
        }
      }
      this.status = true
      switch (evento) {
        case 'create':
          this.$emit('create')
          break
        case 'update':
          this.setEntity(element.idEntity)
          this.$emit('update', element)
          break
        case 'delete':
          this.setEntity(element.idEntity)
          this.$emit('remove', element)
          break
        case 'view':
          this.setEntity(element.idEntity)
          this.$emit('view', element)
          break
      }
    }
  }
}
</script>

<style scoped>
.cursor {
  cursor: pointer;
}

.line-bottom {
  border-bottom: 1px solid #000;
}

.text-left {
  text-align: left;
}

.success--text {
  color: green;
}

.error--text {
  color: red;
}
</style>
